/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';

import { Button, Heading, Loading } from 'school-space-client/components';
import { useBankHolidays } from 'school-space-client/hooks';

import PastBookingCard from '../../cards/PastBookingCard';
import BookingCard from '../../cards/BookingCard';

const css = {
    titleRow: theme => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.layout.baseline
    }),
    content: theme => ({
        minHeight: theme.layout.baseline * 15,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative'
    }),
    loadingOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
    }
};

const RecurringBookingDatesList = ({
    bookings,
    showFutureDates,
    toggleFutureDates,
    loading,
    refetchBookings
}) => {
    const bankHolidays = useBankHolidays();
    const holidays = bankHolidays.map(holiday => holiday.date);

    const showNoDates = !loading && bookings.length === 0;

    return (
        <section>
            <div css={css.titleRow}>
                <Heading level="2" size="large">
                    Booking dates
                </Heading>
                <Button state="text" size="small" onClick={toggleFutureDates}>
                    {showFutureDates ? 'View past dates' : 'View future dates'}
                </Button>
            </div>
            <div css={css.content}>
                {loading && (
                    <div css={css.loadingOverlay}>
                        <Loading fullHeight />
                    </div>
                )}
                {bookings.map(booking =>
                    showFutureDates ? (
                        <BookingCard
                            key={booking.id}
                            booking={booking}
                            onUpdate={refetchBookings}
                            holidays={holidays}
                        />
                    ) : (
                        <PastBookingCard key={booking.id} booking={booking} />
                    )
                )}
                {showNoDates && (
                    <p>
                        There are no {showFutureDates ? 'future dates' : 'past dates'} for this
                        booking
                    </p>
                )}
            </div>
        </section>
    );
};

RecurringBookingDatesList.propTypes = {
    bookings: PropTypes.arrayOf(PropTypes.object).isRequired,
    showFutureDates: PropTypes.bool.isRequired,
    toggleFutureDates: PropTypes.func.isRequired,
    refetchBookings: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
};

export default RecurringBookingDatesList;
